// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"665":"d482dbaa","883":"e8009df3","884":"9207e8f5","987":"987614cd"}[chunkId] + ".chunk.css";
};